import request from '@/utils/request'

/**
 * 获取进口入库列表
 * @param {*} data 
 * @returns 
 */
export const getJKRKList = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/list`,
    data: data
})

/**
 * 获取进口证明列表
 * @param {*} data 
 * @returns 
 */
 export const getJKZList = (type, data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/selectJkhczList/${type}`,
    data: data
})
/**
 * 获取运输证列表
 * @param {*} id 
 * @param {*} data 
 * @returns 
 */
 export const getYSZList = (id, data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/selectYszList/${id}`,
    data: data
})

/**
 * 根据进口证明主键查询进口证明等信息
 * @param {*} id 
 * @returns 
 */
 export const getJKZ = (type,id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/jkrk/selectJkzxxById/${type}/${id}`
})
/**
 * 获取进口入库详情
 * @param {*} id 
 * @returns 
 */
 export const getJKRK = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/jkrk/detail/${id}`
})


/**
 * 新增/编辑进口入库
 * @param {*} data 
 * @returns 
 */
export const addOrUpdSaveJKRK = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/addOrUpdSave`,
    data: data
})


/**
 * 删除进口入库
 * @param {*} data 
 * @returns 
 */
export const deleteJKRK = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/jkrk/remove/${id}`
})

/**
 * （变更保存前）校验库存是否为负数
 * @param {*} data 
 * @returns 
 */
export const changePdkc = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/changePdkcByJkrk`,
    data
})
/**
 * 变更进口入库
 * @param {*} data 
 * @returns 
 */
export const saveChangeApply = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/saveChangeApply`,
    data
})

/**
 * 导出
 * @param {*} data 
 * @returns 
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkrk/excelwriter`,
    data,
    responseType: 'blob'
})

